module.exports = __webpack_public_path__ + "img/angular-4.1b02aac1.png";